import axios from "axios";
import * as yup from "yup";
import { useFormik } from "formik";
import React, { useState } from "react";

import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  FormControl,
  DialogActions,
  DialogContent,
  FormHelperText,
} from "@material-ui/core";

import Loader from "../components/Loader";

export default function DeviceKFilterUpstreamForm({
  initialData,
  deviceSerial,
  setMessage,
  setError,
  open,
  handleOpen,
  callback,
}) {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object({
    username: yup.string("Username").required("Username is required"),
    password: yup.string("Password").required("Password is required"),
  });

  const setUpstream = (requestData) => {
    setLoading(true);

    axios
      .post(`/device/kfilter/upstream/${deviceSerial}`, requestData)
      .then((response) => {
        setMessage("Updated KFilter upstream credentials successfully.");
      })
      .catch((error) => {
        setError(
          error?.response?.data?.detail || "Error updating upstream credentials"
        );
      })
      .finally(() => {
        formik.setSubmitting(false);
        handleOpen(null);
        setLoading(false);
        callback && callback();
      });
  };

  const formik = useFormik({
    initialValues: initialData || { username: "", password: "" },
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      setUpstream({ username: values.username, password: values.password });
    },
  });

  if (loading) {
    return <Loader />;
  } else {
    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={() => handleOpen(null)}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">
            Set KFilter Upstream Credentials
          </DialogTitle>
          <DialogContent>
            <Grid container direction="column" spacing={2}>
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={Boolean(formik.errors.username)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    fullWidth
                    margin="dense"
                    id="username"
                    label="Username"
                    onChange={formik.handleChange}
                    placeholder="Username"
                    value={formik.values.username}
                  />
                  {Boolean(formik.errors.username) && (
                    <FormHelperText id="username-error-text">
                      {formik.errors.username}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={Boolean(formik.errors.password)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    fullWidth
                    margin="dense"
                    type="password"
                    id="password"
                    label="Password"
                    onChange={formik.handleChange}
                    placeholder="Password"
                    value={formik.values.password}
                  />
                  {Boolean(formik.errors.password) && (
                    <FormHelperText id="password-error-text">
                      {formik.errors.password}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={loading || formik.isSubmitting}
              onClick={() => formik.submitForm()}
              variant="contained"
              color="primary"
            >
              Save Credentials
            </Button>
            <Button onClick={() => handleOpen(null)} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
